import type { Quiz, Section } from '@efdigital/ll-addon-data';
import { queryQuizzes } from '@efdigital/ll-admin-v2/data/builders/content/quizzes';
import { querySections } from '@efdigital/ll-admin-v2/data/builders/content/sections';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Store } from '@warp-drive/core';

import type { LibraryClientsEditModel } from '../../client';

export interface LibraryClientsEditHomeModel extends LibraryClientsEditModel {
  sections: Section[];
  quizzes: Quiz[];
}

export default class LibraryClientsClientEditHomeRoute extends Route {
  controllerName = 'library.clients.client.edit';

  @service declare store: Store;

  async model(): Promise<LibraryClientsEditHomeModel> {
    const baseModel = this.modelFor(
      'library.clients.client.edit'
    ) as LibraryClientsEditModel;

    let sections: Section[] = [];
    let quizzes: Quiz[] = [];

    try {
      if (baseModel.client.id) {
        const [sectionsResponse, quizzesResponse] = await Promise.all([
          this.store.request(querySections(baseModel.client.id)),
          this.store.request(queryQuizzes(baseModel.client.id)),
        ]);
        sections = sectionsResponse.content.data;
        quizzes = quizzesResponse.content.data;
      }
    } catch (e) {
      console.warn('Failed to load supporting home data:', e);
    }

    return {
      ...baseModel,
      sections,
      quizzes,
    };
  }
}
